module.exports = __webpack_public_path__ + "static/img/no-data.59da3c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-data.png
// module id = P7fI
// module chunks = 11